import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import {connect} from "react-redux";
import {getCurrentMicroTime} from "../../../../../reducers/timeMeasuring/actions";
import striptags from 'striptags';
import classnames from "classnames";
import {Col, Input, ListGroup, ListGroupItem, Row} from "reactstrap";
import {injectIntl} from "react-intl";

class PresentationDropdown extends Component {

  constructor(props) {
    super(props);

    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.filterOptions = this.filterOptions.bind(this);
  }

  onOpenChange(answerId, content){
    this.props.onDetailsUpdated(this.props.details.map(detail => {
      if(parseInt(detail.answer) === parseInt(answerId)){
        detail.content = content;
      }

      return detail;
    }));
  }

  onChangeSelect(values,action) {
    const {answers} = this.props;
    let {details} = this.props;

    const microTime = getCurrentMicroTime(this.props.startTime);

    switch (action.action) {
      case 'select-option':
        const answer = answers.find(a => a.id === action.option.value);

        if(this.props.isAnswerDisabled(answer.id)){
          return;
        }

        if(answer.blocking){
          details = [{answer: answer.id, microTime}];
        }else{
          details = [...details, {answer: answer.id, microTime}];
        }

        this.props.question.javascripts.map(javascript => {
          if(javascript.action === 'onAnswerSelected'){
            let func = new Function("return " + "function (answer) { " + javascript.code + " }")().bind(this);
            func(answer);
          }
        });

        break;

      case 'remove-value':
        details = details.filter(detail => detail.answer !== action.removedValue.value);
        break;

      case 'clear':
        details = [];
        break;
    }

    this.props.onDetailsUpdated(details);
  }

  filterOptions(option, searchText) {
    const content = this.props.answers.find(answer => answer.id === option.value).content;
    return String(option.value).includes(searchText) || content.toLowerCase().includes(searchText.toLowerCase());
  }

  render() {
    const {answers, details, answersImage} = this.props;

    return (
      <div className="d-flex flex-column dropdown-container">
        <Select
            menuPlacement={"bottom"}
            maxMenuHeight={408}
          class={"dropdown-wrapper"}
            placeholder={this.props.intl.formatMessage({id: 'question.dropdown.open'})}
          isMulti
          value={details.map(detail => {
            const content = answers.find(answer => answer.id === detail.answer).content;
            return {
              value: detail.answer,
              label: (answersImage ? <img src={content} /> : striptags(content)),
            }
          })}
          isOptionDisabled={(option) => this.props.isAnswerDisabled(option.value)}
          onChange={this.onChangeSelect}
          options={answers.map(answer => {
            return {
              value: answer.id,
              label: (answersImage ?
                <div className="container">
                  <div className="row">
                    <img src={answer.content} />
                    <div className="my-auto mx-auto">
                      {answer.description}
                    </div>
                  </div>
                </div> : striptags(answer.content)),
            }
          })}
          isSearchable={this.props.isSearchable}
          filterOption={this.filterOptions}
        />

        <ListGroup className="mt-2">
          {details.map(detail => {
            const answer = answers.find(answer => answer.id === detail.answer);

            if(!answer.isOpen){
              return null
            }

            return <ListGroupItem className="d-flex flex-nowrap">
              <Row className="w-100">
                <Col xs={12} md={5} lg={4} xl={3}><div dangerouslySetInnerHTML={{__html: answer.content}} /></Col>
                <Col xs={12} md={7} lg={8} xl={9}>
                  <Input
                    placeholder={this.props.intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
                    type="text"
                    bsSize="sm"
                    onChange={e => this.onOpenChange(answer.id, e.target.value)}
                    value={detail.content || ''}
                  />
                </Col>
              </Row>
            </ListGroupItem>
          })}
        </ListGroup>
      </div>
    );
  }
}

PresentationDropdown.propTypes = {
  answers: PropTypes.array.isRequired,
  answersImage: PropTypes.bool.isRequired,
  details: PropTypes.array.isRequired,
  isAnswerDisabled: PropTypes.func.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
})(injectIntl(PresentationDropdown));
